"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _validate = require("@/utils/validate");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: "CreatGrade",
  props: {
    user: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    visible: {
      type: Boolean,
      default: function _default() {
        false;
      }
    }
  },
  data: function data() {
    var _formValidate;
    return {
      formValidate: (_formValidate = {
        level_name: '',
        level: '',
        lift_type: 0,
        lift_condition: ''
      }, _defineProperty(_formValidate, "lift_condition", ''), _defineProperty(_formValidate, "vip_withdraw_rate", ''), _defineProperty(_formValidate, "vip_compensate_rate", ''), _defineProperty(_formValidate, "vip_withdraw_rate_status", false), _defineProperty(_formValidate, "vip_compensate_rate_status", false), _defineProperty(_formValidate, "id", null), _formValidate),
      loading: false
    };
  },
  computed: {
    rules: function rules() {
      return {
        level_name: [{
          required: true,
          message: this.$t('qsrdjmc'),
          trigger: 'blur'
        }],
        level: [{
          required: true,
          message: this.$t('qsrgradeNum'),
          trigger: 'blur'
        }, {
          type: 'number',
          message: this.$t('jbbxssz')
        }]
      };
    }
  },
  mounted: function mounted() {
    if (this.user.id) {
      var obj = JSON.parse(JSON.stringify(this.user));
      this.formValidate = obj;
      this.formValidate.vip_compensate_rate_status = obj.vip_compensate_rate_status == 1;
      this.formValidate.vip_withdraw_rate_status = obj.vip_withdraw_rate_status == 1;
    }
  },
  methods: {
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this = this;
      this.$refs.user.validate(function (valid) {
        if (valid) {
          _this.loading = true;
          var data = _objectSpread(_objectSpread({}, _this.formValidate), {}, {
            vip_compensate_rate_status: _this.formValidate.vip_compensate_rate_status ? 1 : 0,
            vip_withdraw_rate_status: _this.formValidate.vip_withdraw_rate_status ? 1 : 0
          });
          _this.user.id ? (0, _user.levelUpdateApi)(_this.user.id, data).then(function (res) {
            _this.$message.success(_this.$t('xgcg'));
            _this.loading = false;
            _this.$emit("cancel");
          }).catch(function () {
            _this.loading = false;
          }) : (0, _user.levelSaveApi)(data).then(function (res) {
            _this.$message.success(_this.$t('xzcg'));
            _this.loading = false;
            _this.$emit("cancel");
          }).catch(function () {
            _this.loading = false;
          });
        } else {
          return false;
        }
      });
    }),
    resetForm: function resetForm(formName) {
      this.$emit("cancel");
    },
    handleClose: function handleClose() {
      this.$emit("cancel");
    }
  }
};
exports.default = _default2;